import type { Progress } from "../progress/model/progress";
import type { LevelSummary } from "./model/level-summary";

export type HubCta =
  | { readonly kind: "start" }
  | { readonly kind: "continue"; readonly levelId: string }
  | { readonly kind: "review"; readonly levelId: string };

/**
 * 稽古の段（S-1）ヒーローCTAの3状態を算出する（`screen-flow.md` §8.1）。
 * 全制覇後も「終わり」の画面を作らず、常に次の一手を示す（N-008）。
 */
export function computeHubCta(levels: readonly LevelSummary[], progress: Progress): HubCta {
  if (levels.length === 0) {
    return { kind: "start" };
  }

  const allStamped = levels.every((level) => progress.stamps.has(level.id));
  if (allStamped) {
    return { kind: "review", levelId: (levels[0] as LevelSummary).id };
  }

  const hasAnyProgress = progress.stamps.size > 0 || progress.clearedDrills.size > 0;
  if (!hasAnyProgress) {
    return { kind: "start" };
  }

  const firstUnstamped = levels.find((level) => !progress.stamps.has(level.id)) as LevelSummary;
  return { kind: "continue", levelId: firstUnstamped.id };
}
